import * as React from "react";
import {useState} from "react";
import {
    DataTableRow,
    DataTableRowHeaderColumn,
    DataTableRowWithActionColumn
} from "../../../components/DataTable";
import {HostedInstanceResource} from "../../../client/resources/hostedInstanceResource";
import OpenDialogButton from "../../../components/Dialog/OpenDialogButton";
import repository from "../../../client/repository";
import SaveDialogLayout from "../../../components/DialogLayout/SaveDialogLayout";
import {Errors} from "../../../components/DataBaseComponent";
import {BusyState} from "../../../components/BusyFromPromise/BusyFromPromise";
import {DoBusyTask} from "../../../components/DataBaseComponent/DataBaseComponent";
import {Text} from "../../../components/form";

const maxNotesLength = 200;

interface InstanceDetailNotesProps {
    instance: HostedInstanceResource;
    setInstance: (instance: HostedInstanceResource) => void;
    errors: Errors;
    busy: BusyState;
    doBusyTask: DoBusyTask;
}

export function InstanceDetailNotes(props: InstanceDetailNotesProps) {
    const notes = props.instance.Notes;
    return (
        <DataTableRow>
            <DataTableRowHeaderColumn>Notes</DataTableRowHeaderColumn>
            <DataTableRowWithActionColumn action={
                <OpenDialogButton label={notes ? "Edit Notes" : "Add Notes"}>
                    <EditNotesDialog {...props}/>
                </OpenDialogButton>}>
                <span style={{whiteSpace: "pre-wrap"}}>{notes}</span>
            </DataTableRowWithActionColumn>
        </DataTableRow>
    );
}

function EditNotesDialog({instance, errors, busy, doBusyTask, setInstance}: InstanceDetailNotesProps) {
    const [notes, setNotes] = useState(instance.Notes ?? "");
    const save = () => {
        return doBusyTask(async () => {
            const updated = await repository.HostedInstances.updateNotes(instance, {Notes: notes === "" ? null : notes});
            setInstance(updated);
            return true;
        });
    };

    return (
        <SaveDialogLayout title="Edit Notes" busy={busy} errors={errors} onSaveClick={save}>
            <Text label="Notes"
                  value={notes}
                  onChange={value => setNotes(value)}
                  hintText="Free-form notes about this instance"
                  maxLength={maxNotesLength}
                  multiLine={true}
                  rows={6}
                  rowsMax={20}/>
        </SaveDialogLayout>
    );
}
